import { getCookie } from 'util/cookies';

// Loading a webpage from mobile app. Check this documentation for details:
// https://joinhomebase.atlassian.net/wiki/spaces/PG/pages/3500376068/Browser-On-Mobile+BOM
export const useIsBrowserOnMobile = () =>
  getCookie('browser_on_mobile_access') === 'true';
